"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outdatedBrowserInfo = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = require("@ori/axios");
var _fetching = require("@ori/fetching");
var _presentationUtils = require("@ori/presentation-utils");
var _browserUpdate = _interopRequireDefault(require("browser-update"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
require("../index.css");
var _parseLocalizations = require("./parseLocalizations");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _defineProperty2.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var outdatedBrowserInfo = exports.outdatedBrowserInfo = function outdatedBrowserInfo(_ref) {
    var currentLanguage = _ref.currentLanguage, staticApiUrl = _ref.staticApiUrl, tenant = _ref.tenant;
    if (_jsCookie.default.get(_constants.SHOULD_BE_CLOSED_COOKIE)) {
        return;
    }
    var test = (0, _presentationUtils.getClientQueryParam)(_constants.TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM) === 'true';
    (0, _axios.axios)("/tenants/".concat(tenant, "/localizations/").concat(_constants.translationsNamespace), {
        baseURL: staticApiUrl,
        method: 'GET',
        params: {
            lang: currentLanguage
        },
        validateStatus: _fetching.validateStatus
    }).then(function(response) {
        var localizations = (0, _fetching.handleResponse)(response, {
            onSuccess: function onSuccess(_ref2) {
                var data = _ref2.data;
                return (0, _parseLocalizations.parseLocalizations)(data.Localizations);
            },
            onError: function onError() {
                return _constants.defaultTranslations;
            }
        });
        (0, _browserUpdate.default)(_objectSpread(_objectSpread({}, _constants.optionsWithoutTranslations), {}, {
            test: test,
            text: {
                msg: localizations.yourBrowserIsOutdated,
                msgmore: localizations.updateYourBrowser,
                bupdate: localizations.update.toUpperCase()
            }
        }));
    }).catch(function(error) {
        console.warn('Cannot start outdated browser info', {
            error: error
        });
    });
}; //# sourceMappingURL=outdatedBrowserInfo.js.map
